import React from 'react';
import {
  Button, Dialog, DialogTitle, DialogContentText, DialogActions, DialogContent
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { STATUS } from '../../utils/const';

const CompletedObjectiveStatusDialog = ({
  open, setCompletedObjectiveDialogOpen, handleStatusChange
}) =>  {
  const { t } = useTranslation();

  const handleSetObjectiveCompleted = () => {
    handleStatusChange(STATUS.COMPLETED);
    setCompletedObjectiveDialogOpen(false);
  };

  return (
    <Dialog
      open={ open }
      onClose={ () => setCompletedObjectiveDialogOpen(false) }
    >
      <DialogTitle>{t('objective.evaluation.status.dialog.set_completed.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('objective.evaluation.status.dialog.set_completed.description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={ handleSetObjectiveCompleted } color="primary" variant="contained">
          {t('objective.evaluation.status.dialog.set_completed.confirm')}
        </Button>
        <Button onClick={ () => setCompletedObjectiveDialogOpen(false) } color="primary" autoFocus>
          {t('objective.evaluation.status.dialog.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompletedObjectiveStatusDialog;
